import * as React from "react";
const SvgMoreHorizontal20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 4,
        fill: "black",
        viewBox: "0 0 16 4"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2.167.167a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667ZM8 .167a1.833 1.833 0 1 0 0 3.667A1.833 1.833 0 0 0 8 .167Zm5.833 0a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667Z",
      clipRule: "evenodd"
    })
  );
export default SvgMoreHorizontal20Px;
